module.exports = __webpack_public_path__ + "img/OrgChartTemp6.ab9d3536.png";